// extracted by mini-css-extract-plugin
module.exports = {"soccer-content-item":"soccer-content-item"};